
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { MainLayout } from './layouts/MainLayout';
import { Login } from './pages/Login';
import AuthPage from './pages/Auth';
import { Dashboard } from './pages/Dashboard';
import { ToolPlayground } from './pages/ToolPlayground';
import { ContentLibrary } from './pages/ContentLibrary';
import { Settings } from './pages/Settings';
import { SuperAdminDashboard } from './pages/SuperAdminDashboard';

export function App() {
  return <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tool/:toolId"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <ToolPlayground />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route path="/tools" element={<Navigate to="/" replace />} />
          <Route
            path="/library"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <ContentLibrary />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Settings />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <SuperAdminDashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>;
}
